import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import { defaultLoansState, defaultLoansTableState } from './state';
import VueTableModule from '~/components/vuetable/store';

export default {
    namespaced: true,
    state: defaultLoansState(),
    actions: actions,
    mutations: mutations,
    getters,

    modules: {
        loans: {
            namespaced: true,
            actions: VueTableModule.actions,
            mutations: VueTableModule.mutations,
            state: VueTableModule.state(defaultLoansTableState())
        }
    }
};
